/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeletedSkillVersion = {
  id: string;
  deleted: boolean;
  object?: "skill.version.deleted" | undefined;
  version: string;
};

/** @internal */
export const DeletedSkillVersion$inboundSchema: z.ZodType<
  DeletedSkillVersion,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  object: z.literal("skill.version.deleted").default("skill.version.deleted"),
  version: z.string(),
});
/** @internal */
export type DeletedSkillVersion$Outbound = {
  id: string;
  deleted: boolean;
  object: "skill.version.deleted";
  version: string;
};

/** @internal */
export const DeletedSkillVersion$outboundSchema: z.ZodType<
  DeletedSkillVersion$Outbound,
  z.ZodTypeDef,
  DeletedSkillVersion
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  object: z.literal("skill.version.deleted").default(
    "skill.version.deleted" as const,
  ),
  version: z.string(),
});

export function deletedSkillVersionToJSON(
  deletedSkillVersion: DeletedSkillVersion,
): string {
  return JSON.stringify(
    DeletedSkillVersion$outboundSchema.parse(deletedSkillVersion),
  );
}
export function deletedSkillVersionFromJSON(
  jsonString: string,
): SafeParseResult<DeletedSkillVersion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeletedSkillVersion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeletedSkillVersion' from JSON`,
  );
}
